import React from 'react';
import HoverTableRow from '../../commonComponents/util/HoverTableRow';
import Toggle from '../../commonComponents/util/Toggle';

export default class UsersTableRow extends React.Component {

    render() {
        const user = this.props.user;
        return <HoverTableRow key={user.userId} onClick={this.props.viewUserDetails.bind(this, user.userId)}>
            <td data-label="Name">
                <p className="bold-text">{user.name}</p>
            </td>
            <td data-label="Department">
                <p>{user.departments.join(', ')}</p>
            </td>
            <td data-label="Email">
                <p>{user.email}</p>
            </td>
            <td data-label="Phone">
                <p>{user.phone}</p>
            </td>
            <td data-label="Role">
                <p>{user.role}</p>
            </td>
            <td data-label="Active">
                <Toggle id={user.userId} name="active" value={user.active}
                    onChange={(name, val) => this.props.toggleActive(val, user)} />
            </td>
        </HoverTableRow>;
    }
}



// WEBPACK FOOTER //
// ./src/components/settingComponents/userSettings/UsersTableRow.jsx